import {nanoid} from 'nanoid';
import {createObjectURL, downloadBlob} from '../../../../../../shared/helpers/resolveAndDownloadBlob';
import {FieldGroup, FileImportCallbacks, Step, WorkStagesServiceData} from '../../../../../../shared/types/form.types';
import {getModelName} from '../../../../../../shared/helpers/modelName';

export const getNewStep = (): Step => {
  return {
    id: `temp_${nanoid()}`,
    title: 'Новый шаг',
    saveOnComplete: false,
    editModeOnly: false,
    fieldGroups: [],
  };
};

export const getNewFieldGroup = (): FieldGroup => {
  const title = 'Новая группа';
  const modelName = getModelName(title);
  return {
    id: `temp_${nanoid()}`,
    title,
    modelName,
    defaultValue: '',
    dataType: undefined,
    fileCount: 0,
    isRequired: false,
    editableAfterSubmit: false,
    editModeOnly: false,
    forWebOnly: false,
  };
};

export const downloadJsonFile = (data: WorkStagesServiceData, filename: string = 'schema.json') => {
  const json = JSON.stringify(data, null, 2);
  downloadBlob(createObjectURL(new Blob([json], {type: 'application/json'})), filename);
};

const createFileInput = (): HTMLInputElement => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json';
  return input;
};

const parseJsonContent = (content: string) => {
  try {
    return JSON.parse(content) as WorkStagesServiceData;
  } catch {
    throw new Error('Ошибка обработки файла');
  }
};

const readFileAsText = (file: File, callbacks?: FileImportCallbacks): void => {
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const text = reader.result as string;
      const parsedData = parseJsonContent(text);
      callbacks?.onSuccess?.(parsedData);
    } catch (error) {
      callbacks?.onError?.(error instanceof Error ? error.message : 'Ошибка обработки файла');
    }
  };

  reader.onerror = () => {
    callbacks?.onError?.('Ошибка чтения файла');
  };

  reader.readAsText(file);
};

const handleFileSelection = (input: HTMLInputElement, callbacks?: FileImportCallbacks): void => {
  input.onchange = () => {
    const file = input.files?.[0];
    if (!file) return;

    readFileAsText(file, callbacks);
  };
};

export const importJsonFile = (callbacks?: FileImportCallbacks): void => {
  const input = createFileInput();

  handleFileSelection(input, callbacks);
  input.click();
};
